module.exports = __webpack_public_path__ + "static/media/icon-siparislerim-2.e0de2053.svg";